import { Events, Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ApiAuthService } from './api-call-providers/api-auth.service';
import { ApiLoginService } from './api-call-providers/api-login.service';
import { ApiLogoutService } from './api-call-providers/api-logout.service';

import { NavService } from './nav.service';
import { StateService, MODE_NORMAL } from './../providers/state.service';
import { ToastService } from './../providers/toast.service';
import { SideMenuService } from './../providers/side.menu.service';
import { LicenseKeyService } from './../providers/license-key.service';
import { ApiAuthStore } from './../providers/store/api.auth.store';
import { PAGES_CONFIG } from './../configs/pages.config';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { EVENTS_CONFIG } from './../configs/events.config';

//*******************************
//* 認証関連に必要な情報を定義
//*******************************

export const CONFIG_USER_ROLE = {
  // ゲスト
//  GUEST: '0001',    // 閲覧が基本、最低限の機能は利用可能
  // 一般ユーザの権限
  DEFAULT: '0010',  // 管理者権限以外の機能は利用可能
  // 管理者ユーザの権限
  ADMIN: '0100',    // 管理者権限として基本的にすべての機能を利用できる
  // ルート
//  ROOT: '1000',    // 申込時に作成されるROOTのユーザ
};

export const ROLES = [
//  { name: 'ゲスト', value: CONFIG_USER_ROLE.GUEST },
  { name: '一般', value: CONFIG_USER_ROLE.DEFAULT },
  { name: '管理者', value: CONFIG_USER_ROLE.ADMIN },
]

/**
 * ログインしているユーザの情報を保持する
 */
interface User {
  code: number,
  msg: string,
  staffId: string,
  staffLoginId:string,
  staffName: string,
  icon?: string,
  token: string,
  role: string,
  password: string,
  expired: string,
  contractGroupId: string,
  contractId: string,
  contractName: string,
  menuType:string,
  isAdultDayCare: boolean,
  sensorOptions: any,
  isLinkedSystem: boolean,
}

export class UserModel implements User {

  code: number = 0;
  msg: string = '';
  staffId: string = '';
  staffLoginId: string = '';
  staffName: string = '';
  icon?: string = '';
  token: string = '';
  role:string = '';
  expired: string = '';
  // TODO: パスワード保持する？
  password: string = '';
  contractGroupId: string = '';
  contractId: string = '';
  contractName: string = '';
  isAdultDayCare: boolean = false;
  menuType:string = '';
  isLinkedSystem: boolean = false;

  // 表示させたいページのキーをBoolean形式で保持している
  menus?: { [pageKey in string]: boolean } = {};

  // 利用するセンサーの情報を保持
  // - リストで取得する
  sensorOptions:any = {};

  constructor(params) {
    this.code = params.code;
    this.msg = params.msg;
    this.staffId = params.staffId;
    this.staffLoginId = params.staffLoginId;
    this.staffName = params.staffName;
    this.icon = params.icon;
    this.token = params.token;
    this.expired = params.expired;
    this.contractGroupId = params.contractGroupId;
    this.contractId = params.contractId;
    this.contractName = params.contractName;
    this.menuType = params.menuType || 'DEFAULT';
    this.isAdultDayCare = params.isAdultDayCare || false;

    this.role = params.role || CONFIG_USER_ROLE.ADMIN;
    this.sensorOptions = params.options || [];
    this.isLinkedSystem = params.isLinkedSystem || false;
  }

}

@Injectable()
export class AuthService {

  licenseKey:string;

  loginTitle:string;

  apiUrl: string;

  // - 表示可能なメニューのリスト: ログインAPIで取得可能
  menuList: {};

  user: User = new UserModel({});

  isLogined: boolean = false;
  loginedList: any = [];

  constructor(
    private navService: NavService,
    private stateService: StateService,
    private sideMenuService: SideMenuService,
    private licenseKeyService: LicenseKeyService,
    private apiAuthService: ApiAuthService,
    private apiLoginService: ApiLoginService,
    private apiLogoutService: ApiLogoutService,
    private toastService: ToastService,
    private apiAuthStore: ApiAuthStore,
    private events: Events,
    private storage: Storage,
    private platform: Platform
  ) {
    // ログイン実行イベント
    this.events.subscribe(EVENTS_CONFIG.LOGIN, (user?: UserModel) => {
      console.log('ログイン実行イベント');
      console.log(user);
      console.log(user.contractGroupId);
      // TODO: menuTypeはサーバ側のAPIが反映されれば、API側で判定して返ってくるようになる予定
      console.log(user.menuType);


      if (user) {
        // *** *** Web版の挙動 *** ***

        // 暫定対応
        // [バイタル連携とセンサー連携が併用された時] => menuType が WSP から WSP_SENSOR として扱われる
        //  このとき、iPadのバイタル連携アプリでは、未送信バイタル連携 の画面が表示されない不具合がある
        //   - WSP_SENSOR で未送信バイタルを表示する機能がないため
        //   - そのため、アプリがアップデートされるまで、 バイタル連携と併用される施設は menuType は、 WSP で返す必要がある

        // 5d4968a9a20d9512c67ce8e5 本番: 医療法人社団青藍会 ハートホーム山口デイケアセンター バイタル連携 ＆ センサー（パラマウントベッド）連携
        // 5bdb9714b4d5226c8b78e6e2 本番: ワイズマン デモ環境 DM4NLZ3RK
        if (user.contractGroupId === "5d4968a9a20d9512c67ce8e5" || user.contractGroupId === "5bdb9714b4d5226c8b78e6e2") {
          user.menuType = 'WSP_SENSOR';
        }

        // 5c188f072a17851d3e8760a7: 本番: ワイズマン 社内サポート１ XS3FKA6FXJM
        if (user.contractGroupId === "5c188f072a17851d3e8760a7") {
          user.menuType = 'WSP_SENSOR_NURSECALL';
        }

        // 暫定対応
        // 内田洋行 絆Core連携の場合
        // - 62255cc9b99ecd74da7cd315: 絆Core(700170011) 本番環境: 法人番号: 700170011
        // - 640fe2f3b99ecd3d0a59bd92: 社会福祉法人貞徳会 ガーデンハウス今伊勢様
        if (user.contractGroupId === "62255cc9b99ecd74da7cd315" || user.contractGroupId === "640fe2f3b99ecd3d0a59bd92") {
          user.menuType = 'WSP_SENSOR';
        }


        // tokenを送信
        this.events.publish(EVENTS_CONFIG.TOKEN, user.token);
        // Storageに保存
        this.storage.set(COOKIES_CONFIG.LOGIN_USER, JSON.stringify(user)).then(() => {
          // 通常ログインモードとして状態を変更する
          this.stateService.state(MODE_NORMAL)

          // ローカルにセット
          this.setUser(user);
          // ローカルのログインリストをセット
          this.setLoginedList(user);
          // ログイン済み
          this.setLogined(true);
          // メニューセット
          this.sideMenuService.setShowMenuList(user.menuType, user.menus);

          // ルーティング処理
          this.events.publish(EVENTS_CONFIG.SET_ROOT, PAGES_CONFIG.TOP_SENSOR_DASHBOARD);
        })
        return
      }
    });

    // オフラインモード切り替え
    this.events.subscribe(EVENTS_CONFIG.LOGIN_OFFLINE, () => {
      console.log("オフラインモードに切りかわった")
      // TODO: データは保持した
      this.toastService.basic("通信環境が良くないため、オフラインモードに切り替えます", 5000, "top");
      this.setLogined(true);
    })
  }

  /**
   * 認証済みか
   * @param bool boolean
   * @return void
   */
  setLogined(bool: boolean): void {
    this.isLogined = bool;
  }

  /**
   * ユーザー情報更新
   * @param user UserModel
   * @return void
   */
  setUser(user: UserModel): void {
    console.log('ログイン成功イベント');
    console.log(user);
    this.user = new UserModel(user);
  }

  /**
   * ログイン認証済みか
   * @return void
   */
  async verify() {
    let _user = await this.storage.get(COOKIES_CONFIG.LOGIN_USER)
    let loginUser:UserModel;
    try {
      loginUser = JSON.parse(_user);
    } catch (e) {
    }
    if (!loginUser) {
      this.navService.goTo(PAGES_CONFIG.LOGIN);
      return;
    }
    this.user = loginUser;

    await this.apiAuthStore.getUrl();

    this.apiAuthService.post({token: this.user['token']});
  }

  /**
   * ログイン処理
   * @param user UserModel
   * @return void
   */
  login(user: UserModel): void {
    this.apiLoginService.post({staffLoginId: user.staffLoginId, password: user.password, contractId: user.contractId, contractGroupId:user.contractGroupId});
  }

  /**
   * ログアウト処理
   * @return Promise<boolean>
   */
  async logout(): Promise<boolean> {

    this.apiLogoutService.post();

    this.setLogined(false);

    await this.storage.remove(COOKIES_CONFIG.LOGIN_USER)
    await this.storage.remove(COOKIES_CONFIG.API_TOKEN);
    await this.apiAuthStore.removeToken()

    // - APIのキャッシュデータも削除しておきたい TODO: ここは非同期で実行でよい？
    for (let d of COOKIES_CONFIG.REMOVE_LOGOUT_DATAS) {
      this.storage.remove(d)
    }
    // - ユーザモデルも初期化している方が良い気がするので TODO: メモリリークとか発生しないかちょい心配
    this.user.staffLoginId = null;
    this.user = new UserModel({});

    this.navService.goTo(PAGES_CONFIG.LOGIN);
    return Promise.resolve(true);
  }

  /**
   * 初期化してライセンスキーの入力画面へ遷移する
   */
  async initLogout() {

    this.clearLoginedList();

    this.setLogined(false);
    // - ローカルストレージのデータを削除
    await this.storage.remove(COOKIES_CONFIG.SYSTEM_TYPE);
    await this.storage.remove(COOKIES_CONFIG.LOGIN_USER);
    await this.storage.remove(COOKIES_CONFIG.LOGINED_LIST);
    await this.storage.remove(COOKIES_CONFIG.API_TOKEN);
    await this.storage.remove(COOKIES_CONFIG.API_URL);
    await this.storage.remove(COOKIES_CONFIG.CDC_CONTRACT);
    await this.storage.remove(COOKIES_CONFIG.SENSORS_OPTIONS);

    // - APIのキャッシュデータも削除しておきたい TODO: ここは非同期で実行でよい？
    for (let d of COOKIES_CONFIG.REMOVE_LOGOUT_DATAS) {
      this.storage.remove(d)
    }
    // - ユーザモデルも初期化している方が良い気がするので TODO: メモリリークとか発生しないかちょい心配
    this.user.staffLoginId = null;
    this.user = new UserModel({});

    this.licenseKeyService.licenseKey = ""
    this.navService.goTo(PAGES_CONFIG.LICENSE_KEY);
    return Promise.resolve(true);
  }

  /**
   * アドミン権限を有しているか
   * @return boolean
   */
  isValidAdminRole(): boolean {
    return true
  }

  /**
   * ログインユーザーリストをセットする
   * @param user UserModel
   * @return void
   */
  setLoginedList(user: UserModel): void {

    user.password = '';

    // 必要なパラメータが存在しているときのみセットする
    if (user.contractId && user.staffId && user.staffLoginId) {
      // staffId and contractIdが同じ
      let update = false
      this.loginedList = this.loginedList.map((d) => {
                            if (d.staffId === user.staffId && d.contractId === user.contractId) {
                              update = true;
                              return user;
                            }
                            return d;
                          });
      if (!update) this.loginedList.push(user);
      this.storage.set(COOKIES_CONFIG.LOGINED_LIST, JSON.stringify(this.loginedList));
    }
  }

  /**
   * ログインユーザーリストを取得する
   * @return []
   */
  async getLoginedList() {
    let _list = await this.storage.get(COOKIES_CONFIG.LOGINED_LIST)
    let loginList = [];
    try {
      loginList = JSON.parse(_list);
    } catch (e) {

    }
    if (Array.isArray(loginList)) {
      this.loginedList = loginList;
    }
    return this.loginedList;
  }

  /**
   * ログインリストを削除する
   * @return void
   */
  clearLoginedList(): void {
    this.loginedList = [];
    this.storage.remove(COOKIES_CONFIG.LOGINED_LIST);
  }

  /**
   * ログインユーザーを削除する
   * @param user UserModel
   * @return Promise
   */
  async clearLoginedUser(user: UserModel) {
    return new Promise((resolve, reject) => {
      this.loginedList = this.loginedList.filter((d) => {
        return d.staffId !== user.staffId;
      });
      this.storage.set(COOKIES_CONFIG.LOGINED_LIST, JSON.stringify(this.loginedList));
      resolve(true)
    })
  }


  //**********************************
  // 権限関連のチェック
  //**********************************
   /**
    * 対象の権限が存在しているかどうか
    *  - 権限は4桁の2進数表記で管理するため、2進数を10進数になおして確認を行う
    *
    * @param role
    */
  public checkAllowRole(role){
    let targetRole = parseInt(role, 2);
    let userRole = parseInt(this.user.role, 2);
    return (targetRole <= userRole);
  }

  /**
   * optionsの中にある、 productCode を利用する
   */
  public getSensorOptionList() {
    if (!this.user.sensorOptions) return [];
    let optionList = [];
    Object.keys(this.user.sensorOptions).forEach((sensorType: string) => {
      Object.keys(this.user.sensorOptions[sensorType]).forEach((sensorKey: string) => {
        let option = this.user.sensorOptions[sensorType][sensorKey];
        optionList.push(option);
      });
    })
    return optionList;
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth.service.ts